// extracted by mini-css-extract-plugin
export var actionButton = "_p2-0";
export var actionMenuContainer = "_p2-i";
export var bubble = "_p2-2";
export var bubbleActionMenu = "_p2-j";
export var bubbleContext = "_p2-6";
export var bubbleItems = "_p2-7";
export var customer = "_p2-3";
export var divider = "_p2-8";
export var fileList = "_p2-9";
export var hiddenComment = "_p2-o";
export var infoAbove = "_p2-a";
export var internal = "_p2-4";
export var lightActionButton = "_p2-1";
export var link = "_p2-b";
export var merchant = "_p2-5";
export var message = "_p2-c";
export var profilePicture = "_p2-e";
export var quillToolbarContainer = "_p2-f";
export var senderDate = "_p2-g";
export var senderDateCustomer = "_p2-h";
export var senderName = "_p2-d";
export var time = "_p2-k";
export var uploadedImage = "_p2-l";
export var username = "_p2-m";
export var xsmall = "_p2-n";